<template>
  <div class="banner-block">
    <!--type  专业与服务1    价格计算2    样例与反馈3   编辑团队4-->
    <div class="banner banner-news" v-if="type == '1'"></div>

    <div class="banner" v-else-if="type == '2'">
      <div class="container-block">
        <div class="info">
          <h1>价格计算</h1>
          <p>论文润色的强大编辑团队</p>
        </div>
        <div class="order">
          <img src="@/assets/imgs/icon2.png" />
          <p>订单累计：{{total}}</p>
        </div>
      </div>
    </div>

    <div class="banner" v-else-if="type == '3'">
      <div class="container-block">
        <div class="info">
          <h1>样例与反馈</h1>
          <p>样例查看，让你更清晰！</p>
        </div>
        <div class="order">
          <img src="@/assets/imgs/icon2.png" />
          <p>订单累计：{{total}}</p>
        </div>
      </div>
    </div>

    <div class="banner" v-else-if="type == '4'">
      <div class="container-block">
        <div class="info">
          <h1>编辑团队</h1>
          <p>论文润色的强大编辑团队</p>
        </div>
        <div class="order">
          <img src="@/assets/imgs/icon2.png" />
          <p>订单累计：{{total}}</p>
        </div>
      </div>
    </div>

    <div class="banner" v-if="type == '6'">
      <div class="container-block">
        <div class="info">
          <h1>论文润色服务</h1>
          <p>提供专业的论文润色服务，让原创论文更加出彩！</p>
          <p>INSIDER OF SCIENCE</p>
          <p>丰富的服务内容，新颖的服务方式，</p>
          <p>专业的服务团队，优惠的服务价格。</p>
        </div>
        <div class="order">
          <img src="@/assets/imgs/icon2.png" />
          <p>订单累计：{{total}}</p>
        </div>
      </div>
    </div>

    <div class="banner" v-if="type == 'recharge'">
      <div class="container-block">
        <div class="info">
          <h1>预存金额</h1>
          <p>提供专业的论文润色服务，让原创论文更加出彩！</p>
          <p>INSIDER OF SCIENCE</p>
          <p>丰富的服务内容，新颖的服务方式，</p>
          <p>专业的服务团队，优惠的服务价格。</p>
        </div>
        <div class="order">
          <img src="@/assets/imgs/icon2.png" />
          <p>订单累计：{{total}}</p>
        </div>
      </div>
    </div>

    

  </div>
</template>

<script>
export default {
  name: 'Banner',
  props: {
    type: {
      // 专业与服务1    价格计算2    样例与反馈3   编辑团队4
      // required: true, // 是否必填
      type: String,
      default: '1',
    },
    total: {
      // 订单总量
      // required: true, // 是否必填
      type: Number,
      default: 0,
    }
  },
  data() {
    return {
    }
  },
  created() {},
  methods: {},
}
</script>
<style lang="scss" scoped>
.banner-block {
  .banner {
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    background-image: url('../../assets/imgs/banner1.png');
    height: 336px;
    color: #ffffff;

    p {
      font-size: 18px;
    }

    .container-block {
      height: 336px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .info {
      color: #ffffff;
      margin-left: 60px;

      h1 {
        font-size: 38px;
      }
    }

    .order {
      margin-right: 220px;
    }
  }

  .banner-news {
    background-image: url('../../assets/imgs/banner3.png');
    height: 430px;
  }
}
</style>